// Generated by CoffeeScript 2.7.0
var FinalVertexConfig;

import VertexConfig from './base.js';

export default FinalVertexConfig = Vue.extend({
  extends: VertexConfig,
  template: `<div class="config-container">
  <div class="config-title">节点属性</div>
  <template v-if='configable'>
    <div class="config-item">
      <div class="config-item-content">
        <div class="list settings-list">
          <div class="list-item">
            <div class="tip">节点名称</div>
            <div class="content">
              <input type="text" v-model.trim='vertex.name' placeholder='节点名称' />
            </div>
          </div>
        </div>
      </div>
    </div>
    <user-boundary-comp :userBoundary='vertex.cc_user_boundary'
                        title='抄送'
                        :extraBoundaryComps='ccUserBoundaryCompOptions'
                        @valueChanged='ccUserBoundaryChangeFunc' />
  </template>
  <template v-else>
    <div class="blankslate">
      <i class="slp-stop"></i>
      <p>该节点不能设置任何属性</p>
    </div>
  </template>
</div>`,
  computed: {
    configable: function() {
      return this.vertex.graph.isRootGraph();
    }
  }
});
